import { Editor } from '../utils/types'


export const savedSelection = (editor: Editor) => {
  editor.savedSelection = editor.selection
}
